
export enum VideoFormat {
    HLS = 'hls',
    DASH = 'dash',
    MP4 = 'mp4',
    UNKNOWN = 'unknown'
}